/** Slugify an English blog category name into its URL form: "Technical SEO" -> "technical-seo". */
export function categoryToSlug(name: string) {
  return name
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}
